import { Component, inject } from '@angular/core';
import { VendorContactTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorContactTypeCreateDto,
  VendorContactTypeDto,
  VendorContactTypeExcelDownloadDto,
  VendorContactTypeUpdateDto,
} from '../proxy/controlling/dtos/vendor-contact-type';
import { VENDORCONTACTTYPE_CONFIG, VENDORCONTACTTYPE_FIELDS } from './vendor-contact-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-vendor-contact-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorContactTypeService, ConfirmationService],
  templateUrl: './vendor-contact-type.html',
  styleUrl: './vendor-contact-type.scss',
})
export class VendorContactType extends BaseCrudComponent<
  VendorContactTypeDto,
  VendorContactTypeCreateDto,
  VendorContactTypeUpdateDto,
  VendorContactTypeExcelDownloadDto
> {
  service = inject(VendorContactTypeService);
  config = VENDORCONTACTTYPE_CONFIG;
  fields = VENDORCONTACTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorContactTypeDto): VendorContactTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorContactType';
  }
}
